import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    addCalculator,
    changeFieldWithContext,
    closeCalculator,
    initCalculator, submit,
    updateCarModels
  } from "../../actions/calculator";
import {calculatorToLead} from "../../actions/lead";
import {dumpState} from "../../actions/localStorage";
import styled from "styled-components";
import routeHelper from "../../helpers/RouteHelper";
import NavBar from "../../components/nav-bar/NavBar";
import Configurator from "../../components/configurator/Configurator";
import {changeField, fetchCarModelDetails, prefillFormIfPossible, resetForm,} from "../../actions";
import currencyHelper from '../../helpers/CurrencyHelper';
import ConfirmationPopup from "../../components/configurator/ConfirmationPopup";
import {apiSubmitApplication} from "../../apis/calculator";
import ICON_ARROW_NEXT from './arrow-next.png';
import LoadingLayer from "../../components/LoadingLayer";
import Dropdown from 'component-dropdown';
import PropTypes from 'prop-types';

const options=[""]

class CalculatorPage extends Component {
    componentDidMount() {
        this.props.initPage();

        // if (sessionStorage.getItem('isApplied').toString() == 'true'){
        //     this.props.history.push(`/confirmation`);
        // }
    }

    checkEligibility = async (calculatorId) => {
        let calculator = this.props.calculators[calculatorId];
        await this.props.calculatorToLead(calculator);
        this.props.history.push(`${routeHelper.urlPrefixForZone(this.props.context)}/lead`);
    };

    constructor(props) {
        super(props);
        this.state = {
          showPopup: false,
          yearvalue:'',
          monthvalue:'',
          myDateA:'',   
        };
    }
    onChange(e) {
        this.setState({
          yearvalue: e.target.value,
        })
    }
    onCancel() {
        this.setState({
            showPopup: false
          })
    }
    onChangeMonth(e) {
        this.setState({
          monthvalue: e.target.value,
        })
    }
    togglePopup() {
        this.setState({
          showPopup: !this.state.showPopup,
        });
    }

    onSubmit() {
        const s1 = this.state.yearvalue+'-';
        const s2 = this.state.monthvalue <= 9 ? '0'+this.state.monthvalue+'-' : this.state.monthvalue+'-'; 
        const s3 = '01';
        var result = ''.concat(s1, s2, s3);
        var myDate = new Date(result);
        var desiredMonth = myDate.toISOString();
        const {dispatch} = this.props;
        dispatch({type: 'setDesiredMonth', payload: {
            desiredMonth
        }});

            // let prefix = '';
            // this.props.history.push(`${prefix}/confirmation`);
              
    }

    render() {
        const {context} = this.props;
        const {entities, ui, form, onFieldChange, onSubmit} = this.props;
        const pkg = form.package && entities.packages[form.package];
        let monthlyLeasingFeeValueFormatted = pkg && `¥${currencyHelper.formatCurrencyJP(pkg.monthlyLeasingFee)}`;
        let selfContributionValueFormatted = pkg && `¥${currencyHelper.formatCurrencyJP(pkg.selfContribution)}`;
       
        let deliveryDate;
        let deliveryMonth;
        let deliveryMonthArr;
        let delivery;
        {
            deliveryDate = new Date(pkg && pkg.deliveryMonth);
            deliveryMonth = deliveryDate.toDateString();
            deliveryMonthArr = deliveryMonth.split(' ');
            delivery = deliveryMonthArr[1]+' '+deliveryMonthArr[3];
        }
        var month = (deliveryDate.getMonth())+ 1;
        var deliYear = `${pkg && pkg.deliveryMonth}`.split("-")[`${pkg && pkg.deliveryMonth}`.split("-").length-3];
        var deliMonth = `${pkg && pkg.deliveryMonth}`.split("-")[`${pkg && pkg.deliveryMonth}`.split("-").length-2];
        var futureYear = parseInt(deliYear)+2;

        var d = new Date();
        var thisyear = d.getFullYear();
        var thismonth = d.getMonth();
        var currentDate = new Date(thisyear, thismonth)
        var cauurentYear = parseInt(thisyear)+2;
       
        var sameDeliYear =  parseInt(thisyear)+1;
        var increaseYear =  parseInt(sameDeliYear)+2;
        
        var oneMonthPlus = (d.getMonth())+ 2;

        let currentMonth = parseInt(thismonth)+1;

        let startMonths = [];
        if ( deliveryDate > currentDate ) {
            var monthval = month;
            for (let i = month; i <= 12; i++) {
                startMonths.push(<option key={i}>{i}</option>)
            }
            
        } else {
            let pmonth;
            if ( currentMonth  == 12 ){
                pmonth = 1;
            }else {
                pmonth = parseInt(currentMonth)+1;
            }
            var monthval = pmonth;
            for (let i = pmonth; i <= 12; i++) {
                startMonths.push(<option key={i}>{i}</option>)
            }
        }
        let months =[];
        for (let i = 1; i <= 12; i++) {
            months.push(<option key={i}>{i}</option>)
        }

        let years =[];
        if ( deliveryDate > currentDate ) {
            var yearval = deliYear;
            for (let i = deliYear; i <= futureYear; i++) {
                years.push(<option key={i} value={i}>{i}</option>);
            }
        }else {
            let pyear;
            let pcauurentYear;
            let currentMonth = parseInt(thismonth)+1;
            if( currentMonth == 12){
                pyear = parseInt(thisyear)+1;
                pcauurentYear = parseInt(cauurentYear)+1;
            }else {
                pyear = thisyear;
                pcauurentYear = cauurentYear;
            }
            var yearval = pyear;
            for (let i = pyear; i <= pcauurentYear; i++) {
                years.push(<option key={i} value={i}>{i}</option>);
            }
        }

        if (this.state.yearvalue > deliveryMonthArr[3]){
            var trueVal = true;
        }

        const isEditMode = trueVal;
        const StartYearPost = yearval;
        const StartMonthPost = monthval;
        
        // if ( this.state.yearvalue == '' || this.state.yearvalue == undefined ) {
        //     if ( deliveryDate > currentDate ) {
        //         this.state.yearvalue = deliYear;
        //     } else {
        //         if( currentMonth == 12){
        //             this.state.yearvalue =  parseInt(thisyear)+1;
        //         }else {
        //             this.state.yearvalue = thisyear;
        //         }
        //     }
        // }

        if (pkg == null) {
            return <LoadingLayer/>
        }
        return <div className={this.props.className}>
            <Configurator entities={entities} ui={ui} form={form} onFieldChange={onFieldChange} onSubmit={()=>this.props.onSubmit()} onConfirm={()=>this.props.onConfirm()}/>
            
            

            {this.state.showPopup ? 
                            <ConfirmationPopup
                                text={<div className="confirmTxt pt-0">
                                        {/* <button onClick={e=>this.onConfirm()} className="btn btn-primary popbtn"> No </button> */}
                                        
                                        <div>
                                            <p className="dsrWrap"> Desired Registration Month <span className="qs">i 
                                                <span className="popover above">
                                                    <span className="innerI">i</span>
                                                    <span className="innerP">Select a date which is after the delivery month</span>
                                                </span>
                                            </span></p>
                                        </div>
                                        <div className="selectWrap">
                                            <select value={this.state.yearvalue?this.state.yearvalue:this.state.yearvalue=StartYearPost} onChange={this.onChange.bind(this)} className="form-control">{years}</select> 
                                           {/* <br/> <select 
                                            value={this.state.yearvalue}
                                            onChange={this.onChange.bind(this)} className="form-control">
                                                {options.map(option => {
                                                    {
                                                        
                                                        const option = [];
                                                        if ( deliveryDate > currentDate ) {
                                                            for (let i = deliYear; i <= futureYear; i++) {
                                                                option.push(<option key={i} value={i}>{i}</option>);
                                                            }
                                                        }else {
                                                            let pyear;
                                                            let pcauurentYear;
                                                            let currentMonth = parseInt(thismonth)+1;
                                                            if( currentMonth == 12){
                                                                pyear = parseInt(thisyear)+1;
                                                                pcauurentYear = parseInt(cauurentYear)+1;
                                                            }else {
                                                                pyear = thisyear;
                                                                pcauurentYear = cauurentYear;
                                                            }
                                                            for (let i = pyear; i <= pcauurentYear; i++) {
                                                                option.push(<option key={i} value={i}>{i}</option>);
                                                            }
                                                        }
                                                        return option;
                                                } })}
                                            </select> */}
                                            { isEditMode
                                                ?
                                                <select value={this.state.monthvalue} onChange={this.onChangeMonth.bind(this)} className="form-control">{months}</select> 
                                                :
                                                <select value={this.state.monthvalue?this.state.monthvalue:this.state.monthvalue=StartMonthPost} onChange={this.onChangeMonth.bind(this)} className="form-control">{startMonths}</select> 
                                            }
                                            {/* { isEditMode
                                                ?
                                                <select value={this.state.monthvalue} onChange={this.onChangeMonth.bind(this)} className="form-control">{months}</select> 
                                                : 
                                                currentMonth == 12
                                                ?   
                                                <select value={this.state.monthvalue?this.state.monthvalue:this.state.monthvalue=1} onChange={this.onChangeMonth.bind(this)} className="form-control">{startMonths}</select>
                                                :
                                                <select value={this.state.monthvalue?this.state.monthvalue:this.state.monthvalue=deliMonth} onChange={this.onChangeMonth.bind(this)} className="form-control">{startMonths}</select>
                                                // <select value={this.state.monthvalue?this.state.monthvalue:this.state.monthvalue=deliMonth} onChange={this.onChangeMonth.bind(this)} className="form-control">{startMonths}</select>
                                            }                                           */}
                                        </div>

                                        <p className="mt-3"> Do you want to apply for this vehicle?</p>
                                        <button onClick={e=>this.onSubmit()} className="btn btn-primary popbtn"> Yes </button>
                                        
                                        <button onClick={()=>this.onCancel()} className="btn btn-primary popbtn"> No </button>
                                        
                                    </div>}
                            />
                            : null
                        }

        </div>
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        ...state.calculator,
        context: state.context,
        calculator: state.calculator
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        // async onConfirm() {
        //     let prefix = '';
        //     this.history.push(s${prefix}/`);
        // },

        onConfirm(){
            let prefix = '';
            this.history.push(`${prefix}/`);
        },

        async initPage() {
            let match = this.match;
            dispatch(resetForm());
            await dispatch(fetchCarModelDetails(match.params.variantId, match.params.isNew, this.context));
            dispatch(prefillFormIfPossible());
        },

        calculatorToLead: (calculator) => {
            dispatch(calculatorToLead(calculator));
            dispatch(dumpState());
        },

        onFieldChange: (field, val) => {
            console.log(field);
            console.log(val)
            dispatch(changeField(field, val));
        },

        // async onSubmit() {
        //     let prefix = '';
        //     const result = await dispatch(submit());
        //     console.log('onSubmit:result: ', result);
        //     if(result == true){
        //         this.history.push(`${prefix}/confirmation`);
        //     }else{
        //         this.history.push(`${prefix}/`);
        //     }
        // }
        
    }
};


const ConnectedCalculatorPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(CalculatorPage);

const StyledConnectedCalculatorPage = styled(ConnectedCalculatorPage)`
    .confirmTxt .dsrWrap {
        padding-top: 30px;
        position: relative;
    }
    .selectWrap {
        width: 200px;
        margin: 0 auto;
        select {
            width: 49%;
            display: inline-block;
        }
        select:first-child {
            margin-right: 2%;
        }
    }
    .qs {
        border-radius: 100%;
        color: #ced4da;
        cursor: default;
        display: inline-block;
        font-size: 10px;
        font-weight: bold;
        height: 13px;
        line-height: 13px;
        position: relative;
        text-align: center;
        width: 13px;
        border: 1px solid #ced4da;
        top: -20px;
        left: -15px;
        .popover {
            background: rgb(238,240,244);
            border-radius: 5px;
            color: #212529;
            display: none;
            border: 1px solid #ced4da;
            font-size: 12px;
            left: -2px;
            top: -17px;
            padding: 7px 10px;
            position: absolute;
            width: 200px;
            min-height: 50px;
            z-index: 4;
            .innerI {
                width: 13px;
                height: 13px;
                line-height: 13px;
                border-radius: 100%;
                font-size: 10px;
                border: 1px solid;
                text-align: center;
                margin-top: 3px;
                float: left;
                display: block;
            }
            .innerP {
                width: 158px;
                margin-left: 7px;
                float: left;
                display: block;
            }
            @media(min-width: 320px) and (max-width: 380px){
                top: -10px;
                left: -165px;
            }
            @media(min-width: 361px) and (max-width: 400px) {
                top: -10px;
                left: -140px;
            }
            @media(min-width: 401px) and (max-width: 450px) {
                top: -10px;
                left: -120px;
            }
            @media(min-width: 451px) and (max-width: 520px) {
                top: -10px;
                left: -100px;
            }
            @media(min-width: 521px) and (max-width: 630px) {
                top: -10px;
                left: -80px;
            }
            @media(min-width: 631px) and (max-width: 680px) {
                top: -10px;
                left: -70px;
            }
            @media(min-width: 681px) and (max-width: 750px) {
                top: -10px;
                left: -40px;
            }
            @media(min-width: 751px) and (max-width: 900px) {
                top: -10px;
                left: -20px;
            }
            /* &:before {
                border-top: 7px solid rgba(0,0,0,0.85);
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                bottom: -7px;
                content: '';
                display: block;
                left: 50%;
                margin-left: -7px;
                position: absolute;
            } */
        }   
        &:hover {
            .popover {
                display: block;
                -webkit-animation: fade-in .3s linear 1, move-up .3s linear 1;
                -moz-animation: fade-in .3s linear 1, move-up .3s linear 1;
                -ms-animation: fade-in .3s linear 1, move-up .3s linear 1;
            }
            }
        }

    .installment-bar {
    height: 82.5px;
    padding-top: 17px;
    background-color: grey;
    // position: fixed;
    z-index: 10;
    bottom: 0px;
    width: 100%;
    left: 0px;
    text-align: center;

    &, &__padding {
    width: 100%;
    height: 82.5px;
    }

    &__padding {
    margin-top: 20px;
    }

    .instalment{
    cursor: pointer;
    display: inline-block;
    }

    .instalment__amount-value {
        font-size: 22px;
        color: white;
        font-weight: lighter;
        cursor: pointer;
        @media(max-width: 350px){
            font-size: 20px;
        }
        @media(max-width: 320px){
            font-size: 17px;
        }
    }

    .instalment__self {
        font-size: 14px;
        text-align: right;
        color: white;
        font-weight: lighter;
        cursor: pointer;
        @media(max-width: 350px){
            font-size: 17px;
        }
        @media(max-width: 320px){
            font-size: 15px;
        }
    }

    .instalment__amount {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    padding-right: 10px;
    line-height: 25px;
    }

    .instalment__arrow {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    height: 25px;
    width: auto;
    margin: 0 5px;
    }

    .instalment__month {
    font-size: 16px;
    color: #eee;
    font-weight: 100;
    cursor: pointer;
    }

    .instalment__check-eligibility {
    font-size: 36px;
    color: #fff;
    font-family: 'CorporateS-Bold';
    text-align: right;
    cursor: pointer;
    border-left: 1px solid #DDDDDD;
    display: inline-block;
    padding-left: 15px;
    padding-right: 5px;
    margin-left: 5px;
    vertical-align: middle;
    min-height: 50px;
    }

    }
`;

export default StyledConnectedCalculatorPage;



// WEBPACK FOOTER //
// ./src/containers/calculator-page/CalculatorPage.js